
import { Button } from "@/components/ui/button";
import { EditStaffDialog } from "../EditStaffDialog";
import { Trash2 } from "lucide-react";
import { Staff } from "@/types/staff";

interface StaffActionsProps {
  staff: Staff;
  onDelete: (staff: Staff) => void;
  onStaffUpdated: () => void;
}

export const StaffActions = ({ staff, onDelete, onStaffUpdated }: StaffActionsProps) => {
  return (
    <div className="flex items-center gap-2">
      <EditStaffDialog
        staffId={staff.id}
        initialValues={staff}
        onStaffUpdated={onStaffUpdated}
      />
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onDelete(staff)}
      >
        <Trash2 className="h-4 w-4 text-red-500" />
      </Button>
    </div>
  );
};
